// @flow
import styled from "styled-components"
import StyledLink from "components/StyledLink"

export const StyledLogoLink = styled(StyledLink)`
  flex-shrink: 0;

  svg {
    fill: ${(props) => props.theme.color.primaryText};
    transition: fill 0.25s ease;
  }
`;

export const StyledLogo = styled.img`
  width: 97px;
  height: 37px;
  object-fit: contain;
`



// WEBPACK FOOTER //
// ./src/components/LogoLink/styled.js